// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TKhO","newExpiryDate":"styles_newExpiryDate__3rl-P","footer":"styles_footer__ISm5W"};